import { Route } from '@angular/router';
import { AppUrls } from '../../../../../../common/dto/app-urls';

export const BannersRoute: Route = {
  path: AppUrls.Dashboard._.Announce._.Banners.relativeUrl,
  children: [
    {
      path: AppUrls.Dashboard._.Announce._.Banners._.BannerList.relativeUrl,
      loadComponent: () => import('./banner-list/banner-list.component').then(_ => _.BannerListComponent),
      pathMatch: 'full',
    },
    {
      path: AppUrls.Dashboard._.Announce._.Banners._.BannerEditor.relativeUrl,
      loadComponent: () => import('./banner-editor/banner-editor.component').then(_ => _.BannerEditorComponent),
    },
    {
      path: '**',
      redirectTo: AppUrls.Dashboard._.Announce._.Banners._.BannerList.relativeUrl,
    },
  ],
};
